<template>

    <header-index />
    <!-- 面包屑导航 -->
    <breadCrumb/>

    <article>
        <!-- Product Details Section -->
        <packagingFirstSection class="container mx-auto py-8 px-4" :article="article" />

        <!-- main detail Section -->
        <packagingTabDetail class="container mx-auto py-8 px-4 pb-0" :article="article" /> 
    </article>
    
    <packagingInquery />

    <footer-index />

</template>

<script setup lang="ts" name="ArticlePackaging">
    import type { Article, Category } from '~/types';
    import headerIndex from '../../components/header/header-index.vue'
    import footerIndex from '../../components/footer/footer-index.vue'
    import breadCrumb from '../../components/common/breadCrumb.vue';
    import packagingFirstSection from '../../components/article/packagingFirstSection.vue'
    import packagingTabDetail from '../../components/article/packagingTabDetail.vue'
    import packagingInquery from '../../components/article/packagingInquery.vue'
    const cmsInfo = await cmsUtils.getCmsInfo()

    const props = defineProps<{
        article: Article,
        category: Category
    }>()

    // 下面是的处理是为了生成JSON-LD数据 
    const route = useRoute()
    const canonicalUrl = (cmsInfo.website.https ? 'https://' : 'http://') + cmsInfo.website.domain + route.path.replace('.html','')
    useHead({
        script: [
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Product',
                    name: props.article.title,
                    description: props.article.description,
                    ...(props.article.sku ? { sku: props.article.sku } : {}),
                    ...(props.article.imageUrl ? { image: props.article.imageUrl } : {}),
                    ...(props.article.keywords ? { keywords: props.article.keywords } : {}),
                    ...(props.category?.title ? { category: props.category.title } : {}),
                    ...(props.article.createTime ? { datePublished: props.article.createTime } : {}),
                    brand: { '@type': 'Brand', name: cmsInfo.website.title },
                    author: {
                        '@type': 'Organization',
                        name: cmsInfo.website.title,
                        sameAs: 'https://www.linkedin.com/company/leaflypackaging'
                    },
                    publisher: {
                        '@type': 'Organization',
                        name: cmsInfo.website.title,
                        sameAs: 'https://www.linkedin.com/company/leaflypackaging'
                    },
                    mainEntityOfPage: { '@type': 'WebPage', '@id': canonicalUrl },
                    url: canonicalUrl
                })
            }
        ]
    })
</script>

<style scoped lang="scss">


</style>
